import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import type { BannerSuggestion } from '@core/tellent-assistant-types';
import { IconComponent } from '@core/user-interface-legacy';

import { TellentAssistantBrandMarkComponent } from '../brand-mark/tellent-assistant-brand-mark.component';

@Component({
  selector: 'tellent-assistant-suggestion-banner-view',
  imports: [IconComponent, TellentAssistantBrandMarkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <tellent-assistant-brand-mark class="brand" [size]="20" />
    <span class="text">{{ suggestion().text }}</span>
    <rt-icon name="keyboard-arrow-right" colorToken="colorIconAiStrongDefault" class="chevron" />
  `,
  styleUrl: './tellent-assistant-suggestion-banner.component.less',
  host: {
    role: 'button',
    tabindex: '0',
    '[class.compact]': "size() === 'compact'",
    '(click)': 'bannerClick.emit()',
    '(keydown.enter)': 'bannerClick.emit()',
    '(keydown.space)': 'bannerClick.emit()',
  },
})
export class TellentAssistantSuggestionBannerComponent {
  public readonly suggestion = input.required<BannerSuggestion>();
  public readonly size = input<'default' | 'compact'>('default');
  public readonly bannerClick = output<void>();
}
